export const environment = {
    production: false,
    LAUNCHDARKLY_CLIENT_ID: '6177d27ec9dff82419893c1c',
    PAYMENTS_PORTAL_API: 'https://payments-portal-api.dev.sfey.com',
    TPS_AUTH_URL: 'https://auth.pg.test.sfey.com',
    OAUTH_CLIENT_ID: 'PaymentsPortalAdminDev1',
};
